//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            puzzles: [
                {
                    image: 'w3d5windenergyexpert.png',
                    x: 480,
                    y: 510,
                    width: 152,
                    height: 211,
                    correctDropAreaIndex: 1,
                    dropAreaIndex: -1
                },
                {
                    image: 'w3d5energyadviser.png',
                    x: 670,
                    y: 540,
                    width: 170,
                    height: 140,
                    correctDropAreaIndex: 2,
                    dropAreaIndex: -1
                },
                {
                    image: 'w3d5mechanic.png',
                    x: 920,
                    y: 580,
                    width: 189,
                    height: 81,
                    correctDropAreaIndex: 0,
                    dropAreaIndex: -1
                }
            ],
            dropAreas: [
                {
                    xMin: 402,
                    xMax: 604,
                    yMin: 185,
                    yMax: 513
                },
                {
                    xMin: 627,
                    xMax: 831,
                    yMin: 185,
                    yMax: 513
                },
                {
                    xMin: 848,
                    xMax: 1053,
                    yMin: 185,
                    yMax: 513
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.correctDropAreaIndex === puzzle.dropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showHoverBg = false;

            puzzle.x = x;
            puzzle.y = y;
            puzzle.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                puzzle.x >= area.xMin - puzzle.width / 2 &&
                puzzle.x <= area.xMax - puzzle.width / 2 &&
                puzzle.y >= area.yMin - puzzle.height / 2 &&
                puzzle.y <= area.yMax - puzzle.height / 2
            );

            if (puzzle.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    puzzle.x = this.dropAreas[puzzle.dropAreaIndex].xMin + 100 - puzzle.width / 2;
                    puzzle.y = 290;
                });
            }
        }
    }
};
